import { Loading, Skeleton } from '@redriverpress/system'

export default function VideosSkeleton() {
  return (
    <>
      <Skeleton
        height='30vw'
        maxHeight='22.5rem'
        width='100%'
        borderRadius='rounded'
      />
      <Loading height='20vh' />
    </>
  )
}
